import React from 'react';

function About() {
  return (
    <div className="about-container">
      <section id="about" />

      <div className="about">
      Welcome to my digital realm! I'm Ritwik Goel, studying Computer Engineering at Columbia University. My passion lies at the crossroads of technology and innovation, with a particular focus on cloud computing, analytics, and software development. My Github showcases my hands-on experience and curiosity in using technology to drive meaningful solutions. Let's explore the ever-changing digital landscape together, where I combine creativity and technical skills to make a difference.
      </div>
    </div>
  );
}

export default About;
